/*
  Accordion click target — blocks/_product-accordion.liquid, blocks/_faq-list.liquid
  ---------------------------------------------------------------------------------
  Native `<details>` only gives the `<summary>` a click target, which leaves the row's
  own padding dead and makes an open row closable only from its heading. This widens
  that to the whole `[data-accordion]` row: anywhere outside the summary toggles it,
  so the panel a shopper just read closes where they are looking.

  Delegated from `document`, so rows swapped in by a section render or a filter change
  need no re-initialisation. With this file blocked the summary still works.
*/
(function () {
  if (window.__accordion) return;
  window.__accordion = true;

  // Anything that does its own thing with a click keeps it.
  var INTERACTIVE = 'a[href], area[href], button, input, select, textarea, label, summary, video, audio, [role="button"], [contenteditable="true"]';

  function selecting() {
    var selection = window.getSelection && window.getSelection();
    return !!selection && !selection.isCollapsed;
  }

  document.addEventListener('click', function (e) {
    // A modified click is the browser's — a new tab, an extension, a range extension.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var target = e.target;
    if (!target || !target.closest) return;

    var row = target.closest('[data-accordion]');
    if (!row || row.tagName !== 'DETAILS') return;

    // The summary is the browser's own control; `closest` already gives a nested row
    // priority over the one wrapping it.
    if (target.closest('summary')) return;
    if (target.closest(INTERACTIVE)) return;

    // Reading a passage out of the panel is not a request to close it.
    if (selecting()) return;

    row.open = !row.open;
  });
})();
